<!-- src/app/page/login-page/login-page.component.html -->
<div class="container">
  <div class="content-wrapper">
    <img class="logo" src="/assets/images/transend-logo-title.png" alt="Transend Logo">

    <div class="title">Command Center Sign In</div>

    <form [formGroup]="loginFormGroup" class="login-form">
      <!-- Email Field -->
      <div class="form-field">
        <label class="field-label" for="email-input">Email</label>
        <mat-form-field appearance="fill" hideRequiredMarker>
          <input matInput formControlName="email" type="email" id="email-input" class="form-input" />
          @if (loginFormGroup.get('email')?.hasError('required')
            && loginFormGroup.get('email')?.touched) {
            <mat-error>
              Email is required
            </mat-error>
          }
          @if (loginFormGroup.get('email')?.hasError('email')
            && loginFormGroup.get('email')?.touched) {
            <mat-error>
              Invalid email
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Password Field -->
      <div class="form-field">
        <label class="field-label" for="password-input">Password</label>
        <mat-form-field appearance="fill" hideRequiredMarker>
          <input matInput formControlName="password" type="password" id="password-input" class="form-input"
            (keydown.enter)="login()" appPasswordViewer #passwordViewer="passwordViewer" />
            <app-password-toggle-button matSuffix [passwordViewer]="passwordViewer"></app-password-toggle-button>
          </mat-form-field>
          @if (loginFormGroup.get('password')?.hasError('required')
            && loginFormGroup.get('password')?.touched) {
            <mat-error>
              Password is required
            </mat-error>
          }
        </div>
      </form>

      <span class="forgot-password">
        <a (click)="resetPassword()">Forgot Password?</a>
      </span>


      @if (loginError) {
        <div class="login-error">
          {{ loginError }}
        </div>
      }

      <div class="form-actions" mat-dialog-actions>
        <button mat-flat-button color="accent" id="sign-in-button" [disabled]="loginFormGroup.invalid || loading"
          (click)="login()">
          @if (!loading) {
            <span>Sign In</span>
          }
          @if (loading) {
            <mat-spinner diameter="30" color="accent"></mat-spinner>
          }
        </button>
      </div>

      <p class="helper">
        Have questions? Contact us at
        <a href="mailto:support@transendfinancial.com">support&#64;transendfinancial.com</a>
      </p>
    </div>
  </div>